import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import UseRegistration from './UseRegistration';
import SVG from 'react-inlinesvg';
import { RegistrationStepType } from '@/types/registration';

import logo from '@/assets/svg/logo_60x60.svg';
import welcomeDesktop from '@/assets/svg/welcome-desktop.svg';
import AppLoaderCircle from '@/components/AppLoaderCircle';
import UseScreenSize from '@/hooks/UseScreenSize';

const RegistrationView = () => {
  const { t } = useTranslation();
  const { isDesktop } = UseScreenSize();
  const { isLoading, role, currentStep, stepProps, RegistrationComponent } = UseRegistration();

  const isWelcomeStep = currentStep === RegistrationStepType.REGISTRATION_WELCOME;

  const isCognitoVerificationCodeStep = currentStep === RegistrationStepType.COGNITO_VERIFY_CODE;

  const showWelcomeBackground = role === 'student' && isDesktop && isWelcomeStep;

  let component = RegistrationComponent ? <RegistrationComponent {...stepProps()} /> : null;

  if (isWelcomeStep) {
    component =
      RegistrationComponent && !isLoading ? <RegistrationComponent {...stepProps()} /> : null;
  }

  const formHeader = !isWelcomeStep && (
    <div className='registration-view-form-header'>
      {
        <>
          <SVG src={logo} />
          <h2>{t('helloBritannica')}</h2>
        </>
      }
      <span>
        {t(isCognitoVerificationCodeStep ? 'emailVerification' : 'pleaseEnterYourDetails')}
      </span>
    </div>
  );

  return (
    <div className='registration-view h-full'>
      {showWelcomeBackground && <SVG className='registration-view-student' src={welcomeDesktop} />}
      <div
        className={classes('registration-view-content', {
          'registration-view-form-content': !isWelcomeStep,
        })}
      >
        {isLoading && (
          <div className='registration-view-loader-wrapper'>
            <AppLoaderCircle />
          </div>
        )}
        {formHeader}
        {component}
      </div>
    </div>
  );
};

export default RegistrationView;
